import React, { Fragment } from "react";
import ReactDOM from 'react-dom';
import PropTypes from "prop-types";
import { Transition } from '@headlessui/react'

function BlockCustomDialog({
    open,
    onClose,
    targetId,
    children,
    overlayClasses = "",
    overlayStyles,
    containerClasses = "",
    containerStyles,
}){
    if(!open)
        return null
    
    const handleEventBubbleUp = (e) => e.stopPropagation()

    const dialog = (
      <Transition appear show={open} as={Fragment}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div
            id="custom-dialog"
            className={
              "h-full w-full top-0 left-0 z-10 absolute inset-0 bg-black bg-opacity-25 rounded-lg flex flex-col " +
              overlayClasses
            }
            style={overlayStyles}
            onClick={onClose}
          >
            <div
              className={"bg-white rounded-xl " + containerClasses}
              style={containerStyles}
              onClick={handleEventBubbleUp}
            >
              {children}
            </div>
          </div>
        </Transition.Child>
      </Transition>
    );
    const target = document.getElementById(targetId);



    return ReactDOM.createPortal(dialog, target)
}

export default BlockCustomDialog;

BlockCustomDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func,
    targetId: PropTypes.string.isRequired, // Target should have position relative css
    children: PropTypes.element.isRequired,
    overlayClasses: PropTypes.string,
    overlayStyles: PropTypes.object,
    containerClasses: PropTypes.string,
    containerStyles: PropTypes.object,
}